<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" :src="`/logo2.svg`" alt="Paradigm Logo">
        <img class="navbar-brand-minimized" :src="`/logo2.svg`" width="30" height="30" alt="Paradigm Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none mr-2" @click="openMenuApproval()">
          <i class="icon-list"></i>
          <b-badge class="rounded-circle" variant="danger">{{ totalApproval }}</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none mr-2" @click="openPage()">
          <i class="icon-bell"></i>
          <b-badge class="rounded-circle" variant="danger">{{ totalNotification }}</b-badge>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
          <b-modal modal-class="modal-custom-image" size="lg" hide-footer top v-model="showNotifcationModal"
            title="Notification">
            <div class="container-iframe mobile-responsive">
              <div class="p-20 bg-white">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <!-- list -->
                    <h3 class="text-center">Member Agreement</h3>
                    <div class="table-responsive">
                      <table class="table table-striped table-hover">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">TRX Date</th>
                            <th scope="col">Member</th>
                            <th scope="col">Branch</th>
                            <th scope="col">Personal Trainer</th>
                            <th scope="col">PT Tier</th>
                            <th scope="col">Price</th>
                            <th scope="col">Status Agreement</th>
                            <th scope="col">Tanggal Click</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in dataMemberAgreement" :key="item.id">
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>{{ item.member.first_name }} {{ item.member.last_name }}</td>
                            <td>{{ item.branch ? item.branch.name : '-' }}</td>
                            <td>{{ item.personal_training ? item.personal_training.name : '-' }}</td>
                            <td>{{ item.id }}</td>
                            <td>{{ item.gross_amount }}</td>
                            <td>{{ item.is_agree == 1 ? 'Success' : 'Waiting' }}</td>
                            <td>{{ item.is_agree_click_date ? formatDate(item.is_agree_click_date, 'DD-MM-YYYY HH:mm') :
                              '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- Button -->
                <div class="row justify-content-center mt-20">
                  <div class="col-md-12">
                    <b-button variant="primary" @click="showNotifcationModal = false">Close</b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </main>
    </div>
    <TheFooter>
      <div>Copyright © {{ appDate }} <strong>Paradigm Fitness</strong>. All Rights Reserved. </div>
      <div class="ml-auto">Version <strong>4.2.17</strong></div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { Auth } from '@/api'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      appDate: moment().format('YYYY'),
      totalNotification: 0,
      showNotifcationModal: false,
      dataMemberAgreement: [],
      totalApproval: 0
    }
  },
  computed: {
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    getNotification() {
      // sales
      if (Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 4) {
        let salesUrl = 'crm/v1/notification/sales/not_agree_notifcation?'
          + 'sales_id=' + Auth.Session.get().paradigm_id
        axios.get(salesUrl).then(response => {
          this.dataMemberAgreement = response.data.data.rows
          this.totalNotification = response.data.data.count >= 10 ? '9+' : response.data.data.count
          this.showNotifcationModal = response.data.data.count > 0 ? true : false
        }).catch(error => {
          console.log('error', error)
        })
      } else if (Auth.Session.get().paradigm_role == 7) {
        let salesUrl = 'crm/v1/notification/personal_trainer/not_agree_notifcation?'
          + 'personal_trainer_id=' + Auth.Session.get().paradigm_id
        axios.get(salesUrl).then(response => {
          this.dataMemberAgreement = response.data.data.rows
          this.totalNotification = response.data.data.count >= 10 ? '9+' : response.data.data.count
          this.showNotifcationModal = response.data.data.count > 0 ? true : false
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    setLocalCache() {
      const expireAt = Date.now() + (2 * 60 * 60 * 1000);

      localStorage.setItem(
        'paradigm_approval_alert_data_loaded',
        JSON.stringify({
          value: true,
          expireAt
        })
      );

      // show alert
      this.alertNotificationApproval()
    },
    getLocalCache() {
      const item = localStorage.getItem('paradigm_approval_alert_data_loaded');

      if (!item) {
        this.setLocalCache()
        return
      }

      const data = JSON.parse(item);

      if (Date.now() >= data.expireAt) {
        localStorage.removeItem('paradigm_approval_alert_data_loaded');

        // show alert
        this.alertNotificationApproval()
      }
    },
    getTotalApproval() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/approval_request/my_requests?status=PENDING').then(response => {
        this.totalApproval = response.data.data.length

        if (this.totalApproval > 0) {
          if (response.data.data[0].approver_id == Auth.Session.get().paradigm_user_id) {
            this.getLocalCache()
          }
        }
      }).catch(error => {
        console.log('error', error)
      })
    },
    alertNotificationApproval() {
      this.$swal({
        title: 'You have ' + this.totalApproval + ' approval request',
        icon: "warning",
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
        // disabled outside click s
        allowOutsideClick: false,
        // show confirm button
        // showConfirmButton: true,
        confirmButtonText: 'View',
        confirmButtonColor: '#3085d6',
        // show cancel button            showCancelButton: true,
        cancelButtonText: 'Later',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.value) {
          this.openMenuApproval()
        } else {
          this.$swal('You can view your approval request in the approval menu', '', 'info') // info
        }
      })
    },
    openPage() {
      if (Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 4) {
        this.$router.push('/notification/sales?id=' + Auth.Session.get().paradigm_id)
      } else if (Auth.Session.get().paradigm_role == 7) {
        this.$router.push('/notification/personal_trainer?id=' + Auth.Session.get().paradigm_id)
      } else {
        // alert
        this.$swal('Info', 'You can`t open this menu!', 'warning')
      }
    },
    openMenuApproval() {
      this.$router.push('/approval?id=' + Auth.Session.get().paradigm_id)
    },
    formatDate(date, format = 'DD MMM YYYY') {
      return moment(date).format(format)
    }
  },
  created() {
    // console.log('tst', Auth.Session.get().paradigm_role)
    this.getNotification()
    this.getTotalApproval()
  }
}
</script>
